import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-loading',
  templateUrl: './dialog-loading.component.html',
  styleUrl: './dialog-loading.component.scss',
})
export class DialogLoadingComponent {
  message = 'กำลังโหลดข้อมูล...';

  private messages = [
    'กำลังโหลดข้อมูล...',
    'กำลังประมวลผล...',
    'ใช้เวลานานกว่าปกติ...',
  ];
  message2 = 'กำลังโหลดข้อมูล...';
  messageChars = this.message2.split('');
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    if (this.data?.message) {
      this.message = this.data.message;
    }

    let i = 0;
    setInterval(() => {
      if (i < this.messages.length - 1) {
        i++;
        this.message = this.messages[i];
      }
    }, 3000);
  }
}
